import {
  E_PAYMENT_STATUS,
  PaymentStatusColor,
  PaymentStatusLabels,
} from "constants/common";
import { FC } from "react";

interface IPaymentStatus {
  status: E_PAYMENT_STATUS;
}
const PaymentStatus: FC<IPaymentStatus> = ({ status }) => {
  return (
    <div
      className={`${PaymentStatusColor[status]} px-4 p-2 text-sm rounded-full`}
    >
      {PaymentStatusLabels[status]}
    </div>
  );
};
export default PaymentStatus;
